import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, createFilePath, convertStylesStringToObject, isVideo } from '../../utils/obj-utils';
import Detailss from '../../elements/InnerPageDetail';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/swiper.min.css';
import './style.scss';

export default function index(props) {
  const { fields } = props;
  const isMobile = isMobileFun();
  const id = props?.params?.pagename;

  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    if (props.eventRef) {
      return {
        sendEvent
      };
    }
  });
  const sendEvent = () => {
    window.Dmp.sectionAction(id);
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
  };
  return (
    <>
      <div className="Price_packet_v1" id={id}>
        <div className="hash"></div>
        {fields.packet && fields.packet.length > 0 && (
          <div className="packet">
            {fields.packet.map((item, i2) => {
              const [packethide, setPackethide] = useState(true);
              return (
                <div className="packetitem" key={i2}>
                  <div
                    className={`title ${isMobile ? (packethide ? 'titlehide' : '') : ''}`}
                    dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('title', isMobile)}`]?.value?.replaceHtml() }}
                  ></div>
                  <div className={`con ${isMobile ? (packethide ? 'packethide' : '') : ''}`}>
                    <div className="img">
                      <img alt="广汽本田" src={`${createFilePath(item?.fields[`${getPrefixField('img', isMobile)}`]?.value)}`} />
                    </div>
                    <div className="list">
                      <div className="in">
                        {item.fields.lists.length > 0 &&
                          item.fields.lists.map((item3, i3) => {
                            return (
                              <div
                                className="item"
                                key={i3}
                                dangerouslySetInnerHTML={{ __html: item3?.fields[`${getPrefixField('title', isMobile)}`]?.value.replaceHtml() }}
                              ></div>
                            );
                          })}
                      </div>
                      {item.fields.lists && item.fields.lists.length > 6 && !isMobile && <div className="more"></div>}
                      {item.fields.tips.value && (
                        <div
                          className="tips"
                          dangerouslySetInnerHTML={{ __html: item?.fields[`${getPrefixField('tips', isMobile)}`]?.value.replaceHtml() }}
                        ></div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            {fields.tips.value && (
              <div
                className="bottomtips"
                dangerouslySetInnerHTML={{ __html: fields[`${getPrefixField('tips', isMobile)}`]?.value.replaceHtml() }}
              ></div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
